import React, { useCallback } from 'react';

import PopperList from '../../../components/PopperList';
import usePopperListItems from '../../hooks/usePopperListItems';
import { mentionsPopperStyles } from '../../styles';
import MentionsListItem from '../MentionsListItem';
import { MentionEntityListProps } from './types';

function MentionEntityList<T>(props: MentionEntityListProps<T>) {
  const {
    onClose,
    onItemClick,
    searchString,
    popperProps,
    initialItems,
    defaultView,
    getMentionNodeAttrs,
    useSearch,
    BaseItem,
  } = props;

  const { data, fetching } = useSearch({
    searchString,
  });
  const items = usePopperListItems<T>({
    fetching,
    initialItems,
    items: data,
    defaultView,
  });

  const onClick = useCallback(
    (item: any) => {
      onItemClick(getMentionNodeAttrs(item));
    },
    [getMentionNodeAttrs, onItemClick],
  );

  return (
    <PopperList
      className={mentionsPopperStyles}
      fetching={fetching}
      items={items}
      popperProps={popperProps}
      renderItem={(item, index, isSelected) => (
        <MentionsListItem
          key={index}
          index={index}
          isSelected={isSelected}
          item={item}
          onClick={() => onClick(item)}>
          {/* @ts-ignore */}
          <BaseItem item={item} />
        </MentionsListItem>
      )}
      onClose={onClose}
      onItemClick={onClick}
    />
  );
}

export default MentionEntityList;
